// ProtectedAdminRoute.jsx
// Wrap admin-only routes with this. Redirects to /admin/login if no token is present.
// Usage in your Routes file:
//   <Route path="/admin/dashboard" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />

import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminLoggedIn } from "./adminApi";

export default function ProtectedAdminRoute({ children }) {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
